import { COMPONENT_NAME as IMAGE_COMPONENT_NAME, IMRImageComponent } from './image.component'

export const IMAGE_MODULE_NAME = 'simax.common.image'

const module = angular.module(IMAGE_MODULE_NAME, [])

module.component(IMAGE_COMPONENT_NAME, new IMRImageComponent())
